import { styled } from "@mui/material"
import { motion } from "framer-motion"

export const MotionSVG = styled(motion.svg)(() => ({}))
